import React from "react";
import { Table, Spinner } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";

const ShowMembersDialog = (props) => {
  const classData = props.class || {};
  const group = props.userGroupMaps.get(classData._id);

  return (
    <BaseDialog
      show={props.show}
      onHide={props.onHide}
      title={props.t("Groups.GroupModal.ShowMembersModal.Title", {
        className: classData.name,
      })}
      body={
        <Table size="sm" className="students-table mt-2">
          <thead>
            <tr>
              <th>
                {props.t("Groups.GroupModal.ShowMembersModal.ColumnEmail")}
              </th>
            </tr>
          </thead>
          <tbody>
            {group ? (
              group.map((user, idx) => (
                <tr key={idx}>
                  <td>{user.email}</td>
                </tr>
              ))
            ) : (
              <Spinner />
            )}
          </tbody>
        </Table>
      }
    />
  );
};

export default withTranslation()(ShowMembersDialog);
